import { ApiFilter } from "@result/rui/utils/api";

import * as species from "#/utils/SpeciesScope";

export function filterLastnostiPvBySpecies(filter = new ApiFilter()) {
  filter.or((orGroup) => {
    species.get()?.forEach((s) => {
      if (s === species.GOATS) {
        orGroup.equal("veljaZaKoze", true);
      }
      if (s === species.SHEEPS) {
        orGroup.equal("veljaZaOvce", true);
      }
      if (s === species.PIGS) {
        orGroup.equal("veljaZaPrasice", true);
      }
      if (s === species.HORSES) {
        orGroup.equal("veljaZaKonje", true);
      }
      if (s === species.CATTLE) {
        orGroup.equal("veljaZaGovedo", true);
      }
    });
  });

  return filter;
}
